(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("hlTU3", function(module, exports) {
const $ca1fc30271ca302f$var$transitionLength = 300;
const $ca1fc30271ca302f$var$openModal = (modal)=>{
    modal.classList.add("--open");
    modal.classList.remove("--hidden");
    modal.dispatchEvent(new Event("opened"));
};
const $ca1fc30271ca302f$var$closeModal = (modal)=>{
    modal.classList.remove("--open");
    modal.dispatchEvent(new Event("closed"));
    setTimeout(()=>{
        modal.classList.add("--hidden");
    }, $ca1fc30271ca302f$var$transitionLength);
};
const $ca1fc30271ca302f$var$initTriggers = ()=>{
    const triggers = document.querySelectorAll("[data-modal-target]:not(.--initialized)");
    triggers.forEach((trigger)=>{
        const modalTarget = document.getElementById(trigger.getAttribute("data-modal-target") ?? "");
        if (!modalTarget) return;
        trigger.addEventListener("click", (event)=>{
            event.preventDefault();
            $ca1fc30271ca302f$var$openModal(modalTarget);
        });
        trigger.classList.add("--initialized");
    });
};
const $ca1fc30271ca302f$var$initModals = ()=>{
    const modals = document.querySelectorAll(".c-modal:not(.--initialized)");
    modals.forEach((modal)=>{
        const closeButtons = modal.querySelectorAll(".c-modal__close");
        modal.style.setProperty("--transtion-length", `${$ca1fc30271ca302f$var$transitionLength}ms`);
        closeButtons.forEach((closeButton)=>{
            closeButton.addEventListener("click", (event)=>{
                event.preventDefault();
                $ca1fc30271ca302f$var$closeModal(modal);
            });
        });
        modal.addEventListener("click", (event)=>{
            if (modal === event.target) $ca1fc30271ca302f$var$closeModal(modal);
        });
        modal.addEventListener("open", ()=>{
            $ca1fc30271ca302f$var$openModal(modal);
        });
        modal.addEventListener("close", ()=>{
            $ca1fc30271ca302f$var$closeModal(modal);
        });
        modal.classList.add("--initialized");
    });
};
const $ca1fc30271ca302f$var$init = ()=>{
    $ca1fc30271ca302f$var$initTriggers();
    $ca1fc30271ca302f$var$initModals();
};
$ca1fc30271ca302f$var$init();
// In case you need reinitialize just dispatch event and you dont have to worry about imports
// document.dispatchEvent(new Event("reinitModals"))
document.addEventListener("reinitModals", $ca1fc30271ca302f$var$init);

});

})();
//# sourceMappingURL=modal.32b92c30.js.map
